export const shouldSkipBattleRoomSessionRestore = ({
  forceRestore = false,
  isLoading = false,
  lastSignature = null,
  nextSignature = null
} = {}) => (
  forceRestore !== true
  && isLoading !== true
  && Boolean(nextSignature)
  && lastSignature === nextSignature
);

export const buildBattleRoomSessionInitiativeSnapshot = (sessionData = {}) => {
  const battleState = sessionData?.battleState || sessionData?.data?.battleState || {};
  const combatState = sessionData?.combatState || sessionData?.data?.combatState || {};
  const savedTokens = Array.isArray(battleState?.tokens) ? battleState.tokens : [];
  const savedOrder = Array.isArray(combatState?.initiativeOrder) && combatState.initiativeOrder.length > 0
    ? combatState.initiativeOrder
    : savedTokens
      .filter((token) => token?.type !== 'map' && token?.type !== 'object')
      .map((token) => ({
        id: token?.id,
        name: token?.name,
        type: token?.type,
        initiative: Number(token?.initiative) || 0
      }))
      .filter((combatant) => combatant.id)
      .sort((left, right) => right.initiative - left.initiative);
  const savedActiveId = combatState?.currentCombatantId || null;
  const activeIndex = savedActiveId
    ? savedOrder.findIndex((combatant) => String(combatant?.id) === String(savedActiveId))
    : -1;
  const numericTurn = Number(combatState?.currentTurn);
  const currentTurnIndex = activeIndex >= 0
    ? activeIndex
    : (Number.isInteger(numericTurn) && numericTurn >= 0 ? numericTurn : 0);
  const combatStarted = combatState?.combatStarted === true;

  return {
    combatants: savedOrder,
    currentTurnIndex,
    activeCombatantId: savedActiveId || savedOrder[currentTurnIndex]?.id || null,
    round: Math.max(1, Number(combatState?.currentRound ?? combatState?.combatRound) || 1),
    isInitiativeConfirmed: combatStarted,
    combatStarted
  };
};

export default shouldSkipBattleRoomSessionRestore;
